// Fotos usadas na Home e nos Serviços (vêm de src/assets/galeria).
// Para trocar uma foto, basta mudar o import correspondente.
import yoga from '../assets/galeria/IMG-20261013-WA0043.jpg';
import yogaPratica from '../assets/galeria/DSCF2909.jpg';
import pilates from '../assets/galeria/DSCF2908.jpg';
import pilatesAneis from '../assets/galeria/DSCF2886.jpg';
import massagem from '../assets/galeria/IMG-20261013-WA0004.jpg';
import terapias from '../assets/galeria/IMG-20261013-WA0027.jpg';
import gabinete from '../assets/galeria/DSCF0483.jpg';
import gabineteCortinas from '../assets/galeria/DSCF0477.jpg';
import cuidados from '../assets/galeria/DSCF0470.jpg';
import salaAulas from '../assets/galeria/DSCF2857.JPG';
import equipa from '../assets/galeria/DSCF0502.jpg';
import materiais from '../assets/galeria/DSCF0872.jpg';
import { urlImagemBlog } from '../services/blog';

export const FOTOS = { terapias, yoga, yogaPratica, pilates, pilatesAneis, massagem, gabinete, gabineteCortinas, cuidados, salaAulas, equipa };

// Faixa "O nosso espaço" na Home
export const FOTOS_ESPACO = [
  { src: salaAulas, alt: 'Sala de aulas de Yoga e Pilates' },
  { src: pilatesAneis, alt: 'Pilates com anel' },
  { src: gabinete, alt: 'Gabinete de massagens e terapias' },
  { src: materiais, alt: 'Materiais de Yoga e Pilates' },
];

// Todas as fotos da galeria, para o admin escolher a imagem de cada serviço.
// O que se guarda no serviço é só o nome do ficheiro (ex: 'DSCF2874.jpg').
// eslint-disable-next-line no-undef
const galeriaContext = require.context('../assets/galeria', false, /\.(png|jpe?g|webp|gif)$/i);

export function listarFotosGaleria() {
  return galeriaContext.keys()
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .map((chave) => ({ nome: chave.replace(/^\.\//, ''), src: galeriaContext(chave) }));
}

// Foto escolhida no admin; devolve null se não houver (ou se o ficheiro já não existir)
export function resolverFotoServico(imagem) {
  // 'blog:123' = imagem de um artigo do blog
  if (imagem && imagem.startsWith('blog:')) return urlImagemBlog(imagem.slice(5));
  if (imagem) {
    const chave = galeriaContext.keys().find((k) => k.replace(/^\.\//, '') === imagem);
    if (chave) return galeriaContext(chave);
  }
  return null;
}
